import { yup } from '@guiker/yup-util'

export const invoiceIdPathParamsSchema = yup.object({
  invoiceId: yup.string(),
})

export type InvoiceIdPathParamsSchema = yup.InferType<typeof invoiceIdPathParamsSchema>
